const onFormatPhone = ({phone}) => {
    const arr = phone.split('')
    arr.splice(0, 0, '+')
    arr.splice(2, 0, '(')
    arr.splice(6, 0, ')')
    arr.splice(10, 0, ' ')
    arr.splice(13, 0, ' ')
    return arr.join('')
}

export { onFormatPhone }